import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=ac7c3d9c&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"
import style0 from "./Orders.vue?vue&type=style&index=0&id=ac7c3d9c&scoped=true&lang=scss&"
import style1 from "./Orders.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7c3d9c",
  null
  
)

export default component.exports